import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

export const DenaliActionContext = createContext({})

export const useDenaliActions = () => {
  return useContext(DenaliActionContext)
}

const INITIAL_STATE = { open: false, subject: null, code: null }

export const useActionManager = () => {
  const [dialogState, setDialogState] = useState(INITIAL_STATE)

  const open = useCallback((code, subject) => {
    setDialogState({
      open: true,
      subject,
      code
    })
  }, [])

  const close = useCallback(() => {
    setDialogState(INITIAL_STATE)
  }, [])

  return useMemo(() => {
    return {
      open,
      close,
      dialogState
    }
  }, [open, close, dialogState])
}

function DenaliActionProvider ({ children }) {
  const value = useActionManager()

  return (
    <DenaliActionContext.Provider value={value}>
      {children}
    </DenaliActionContext.Provider>
  )
}

DenaliActionProvider.propTypes = {
  children: PropTypes.node
}

export default DenaliActionProvider
